import { SecondaryFilter } from "@/modules/Dashboards/AdminDashboard/models/SecondaryFilter";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import {
  EVENT_EMITTER,
  MESSAGE_SNACKBAR
} from "../../constants/GenericSearchConstants";
import { ObjFilterList } from "../../model/List";

@Component({
  name: "FilterTypeInput"
})
export default class FilterTypeInput extends Vue {
  @Prop() itemFilter!: SecondaryFilter;
  @Prop({ default: () => false }) isPrincipal!: boolean;
  @Prop() isMultipleOption!: boolean;
  @Prop() private selectFilter!: ObjFilterList[];

  textFieldClass = STYLE_CLASSES.TEXT_FIELD;

  searchInput = "";

  mounted() {
    this.initFilter();
  }

  get placeholder() {
    return this.itemFilter.placeholder || this.itemFilter.name;
  }

  get selectFilterLocal() {
    return this.selectFilter ?? [];
  }

  set selectFilterLocal(filterSelected: ObjFilterList[]) {
    this.$emit(EVENT_EMITTER.UPDATE_SELECT_FILTER, filterSelected);
  }

  @Watch("selectFilter")
  initFilter() {
    this.searchInput =
      !this.isMultipleOption &&
      this.selectFilterLocal &&
      this.selectFilterLocal.length == 1
        ? this.selectFilterLocal[0].key
        : "";
  }

  change() {
    if (this.isPrincipal) {
      this.$emit(EVENT_EMITTER.CHANGE);
    }
  }

  addItem() {
    const select = this.selectFilterLocal.find(
      select => select.key == this.searchInput
    );

    if (select) {
      Snackbar.popError(MESSAGE_SNACKBAR.FILTER_DATA_REGISTER);
      return;
    }
    const selectFilterLocal = this.isMultipleOption
      ? this.selectFilterLocal
      : [];
    this.selectFilterLocal = [
      ...selectFilterLocal,
      {
        key: this.searchInput,
        name: this.searchInput
      }
    ];
    if (this.isMultipleOption) {
      this.searchInput = "";
    }
    this.change();
  }

  removeFilterSelect(index: number) {
    this.selectFilterLocal.splice(index);
    this.change();
  }
}
